import type { CSSProperties } from 'react';
import type { SectionTitlePresentationVm } from '../viewModels/newHome.vm';

const THEME_FONT_FAMILIES = new Set(['serif', 'sans', 'primary']);

export function isThemeFontFamilyToken(value: string): boolean {
  return THEME_FONT_FAMILIES.has(value);
}

/** Color + responsive font sizes (CSS vars) + optional raw `fontFamily` when not a theme token. */
export function buildSectionTitleStyle(title: SectionTitlePresentationVm): CSSProperties {
  const ff = title.fontFamily?.trim() ?? 'serif';
  const style = {
    ...(title.desktopColor
      ? { color: title.color, ['--nh-title-desktop' as string]: title.desktopColor }
      : { color: title.color }),
    ['--nh-title-fs-m' as string]: title.fontSizeMobile,
    ['--nh-title-fs-d' as string]: title.fontSizeDesktop,
    ...(!isThemeFontFamilyToken(ff) ? { fontFamily: ff } : {}),
  } as CSSProperties;
  return style;
}

export function sectionTitleFontFamilyClass(title: SectionTitlePresentationVm): string {
  const ff = title.fontFamily?.trim() ?? 'serif';
  if (ff === 'serif') return 'font-serif';
  if (ff === 'sans') return 'font-sans';
  if (ff === 'primary') return 'font-primary';
  return '';
}

export function sectionTitleFontWeightClass(weight: string): string {
  switch (weight) {
    case 'normal':
      return 'font-normal';
    case 'medium':
      return 'font-medium';
    case 'semibold':
      return 'font-semibold';
    case 'bold':
      return 'font-bold';
    default:
      return 'font-semibold';
  }
}
